import { jsxs as v, jsx as h } from "react/jsx-runtime";
const o = (l) => /* @__PURE__ */ v(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M22.804 31.99h-1.998v16.189h1.998V31.99ZM32.998 31.99H31v16.104h1.998V31.99ZM42.988 34.241v-2.252H40.99v3.046a13.03 13.03 0 0 1 1.998-.794Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M35.838 53.976H16.002V32.029h-5.977v-6.001h43.951v6.001h-4.053v2.023a13.035 13.035 0 0 1 4.338 1.958h3.71V22.033h-5.756L45.549 7.085h-6.715v-.999H25.165v.999h-6.502l-6.859 14.948h-1.776a4 4 0 0 0-4 4v6.015a4 4 0 0 0 4 4h1.977v17.924a4 4 0 0 0 4 4h23.954a13.216 13.216 0 0 1-4.122-3.997l.001.001ZM19.99 9.081h5.175v.999h13.669v-.999h5.375l5.847 12.951H13.973l6.016-12.951h.001Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M46.801 35.675c-6.138 0-11.114 4.976-11.114 11.114 0 6.138 4.975 11.114 11.114 11.114 6.139 0 11.114-4.976 11.114-11.114 0-6.138-4.976-11.114-11.114-11.114Zm0 19.231c-4.476 0-8.117-3.641-8.117-8.117 0-4.476 3.641-8.117 8.117-8.117 4.476 0 8.117 3.641 8.117 8.117 0 4.476-3.641 8.117-8.117 8.117Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M47.736 49.856h-2.133c.732-.489 1.009-1.27 1.009-2.035 0-.098 0-.196-.016-.293h2.295v-1.791h-2.865c-.163-.424-.277-.798-.277-1.286 0-.863.602-1.27 1.254-1.27.846 0 1.303.569 1.319 1.562l2.133-.569c-.082-1.335-.977-3.012-3.483-3.012-2.279 0-3.581 1.611-3.581 3.207 0 .537.081.977.212 1.367h-.928v1.791h1.579c.033.179.065.358.065.537 0 .96-.667 1.628-1.693 1.986v1.921h5.437c1.807 0 3.028-1.352 3.028-3.19l-2.149-.13c0 .732-.52 1.205-1.205 1.205h-.001Z"
        }
      )
    ]
  }
);
export {
  o as TopUpInStore
};
